import { MovieCheckIcon } from './MovieCheckIcon';

/**
 * author: Colton Wiscombe
 * id 8B5A9F9F-D0F3-4B9A-844F-D6EE34154837
 * name movie-check
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-check.svg
 * tags
 * - Video / Movie 
 */
export const FilmCheckIcon = MovieCheckIcon;
export default FilmCheckIcon